import { getChartTheme } from '../stats/charts/themes/customTheme';
import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import * as echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/dataZoom';
import { TranslateService } from '@ngx-translate/core';
import { getChartSize } from '../stats/charts/chartUtils';
import { tap, first, map } from 'rxjs/operators';
import * as store from 'store';
import { ThemeDirective } from '../../theme/theme.directive';
import { ISession } from '../../models/session';
import { contains, merge } from 'ramda';
import { StatsService } from '../sessions/stats/stats.service';
import { IWidgetOptions } from '../sessions/stats/stats';

const defaultOptions = (data, type) => ({
  title: {},
  tooltip: {
    trigger: 'axis'
  },
  xAxis: {
    type: 'category',
    data: data.map(item => item.date)
  },
  yAxis: {
    type: 'value'
  },
  series: [
    {
      type,
      data: data.map(item => item.value),
      areaStyle: {}
    }
  ]
});

@Component({
  selector: 'app-bar-chart',
  styleUrls: ['./bar-chart.component.scss'],
  template: `
    <div class="flexed full-width ibox-content" style="padding: 2%;">
      <div
        [ngClass]="{ hide: !containsData, 'full-width': true }"
        #chart
        style="width:100%;height:45vh;"
        class="full-width"
      ></div>
      <div
        style="width:100%;height:45vh;"
        [ngClass]="{ hide: containsData, 'full-width': true, 'chart-no-data': true }"
      >
        <i class="fa fa-line-chart" aria-hidden="true"></i>
        <div>{{ 'stats.no_data' | translate }}</div>
      </div>
    </div>
  `
})
export class BarChartComponent implements OnInit, AfterViewInit, OnChanges {
  @Input('session') session: ISession;
  @Input('datefrom') datefrom: Date;
  @Input('dateto') dateto: Date;
  @Input('options') options: IWidgetOptions;

  containsData = false;
  chartInstance: any;
  @ViewChild('chart') chart;

  constructor(private translate: TranslateService, private statsService: StatsService) {}

  ngOnInit() {}
  ngAfterViewInit() {
    setTimeout(() => {
      const parent = this.chart.nativeElement as HTMLDivElement;
      const parentSize = getChartSize(parent);
      const theme = store.get(ThemeDirective.THEME);
      const chartTheme = getChartTheme(theme);
      this.chartInstance = echarts.init(parent, chartTheme, parentSize);
      this.updateBarChart();
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.chartInstance) {
      this.updateBarChart();
    }
  }

  updateBarChart() {
    const options = this.getOptions(this.options.requiredParams || []);
    this.chartInstance.showLoading();
    const postProcess$ = map((data: any) =>
      this.options.postProcess ? this.options.postProcess(data, options) : data
    );
    const setOptions$ = tap(data => {
      setTimeout(
        () =>
          this.chartInstance.setOption(this.createBarChart(data, this.options.chartType || 'bar')),
        100
      );
    });
    const setContainsData$ = tap((data: any) => (this.containsData = data.length > 0));
    const hideLoading$ = tap(() => this.chartInstance.hideLoading());
    const source$ = this.statsService.call(`${this.options.func(this.session.id)}`, options);
    source$.pipe(first(), postProcess$, setOptions$, setContainsData$, hideLoading$).subscribe();
  }

  createBarChart(data: any, type: string = 'bar') {
    return defaultOptions(data, type);
  }

  getOptions(requiredParams: Array<string>) {
    return {
      params: {
        datefrom: contains('datefrom', requiredParams) ? this.datefrom : undefined,
        dateto: contains('dateto', requiredParams) ? this.dateto : undefined
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/bar-chart/bar-chart.component.ts